import styled from "styled-components";
import {HomepageHeaderArenaTileDefaultBox} from "./home-page-header-arena-tile.default.box";

export const HomepageHeaderArenaTileCasino888Box = styled(HomepageHeaderArenaTileDefaultBox)`
  padding-right: 1rem;
  padding-left: 1rem;
  padding-top: 1rem;
  &::after {
    display: none;
  }
`;
